import React from 'react'
import Image from '../../common/Image'
import './identityInfo.scss'
const IdentityInfo = ({ setModal,data }) => {

  return (
    <div className='modal page-modal'>
      <div className='block'>
        <div className='container'>
          <div className="page-header">
            <button className="btn-circle" onClick={() => setModal(false)}>
              <Image src="/images/icons/close.svg" svg />
            </button>
            <div className="page_header__title">
              <h1 className="font-heading">優惠身份</h1>
            </div>
          </div>
          <div className=''>
            <div className='list_block'>
              <div className='desc_flex'>
                <Image src="/images/icons/calendar.svg" />
                <div className='title_block'>
                  <p className='title'>{data.expired_date }</p>
                  <p className='text'>有效期限</p>
                </div>
              </div>
            </div>
            <div className='list_block'>
              <div className='desc_flex'>
                <Image src="/images/icons/info.svg" />
                <div className='title_block'>
                  <p className='title'>{data.car_no}</p>
                  <p className='text'>車輛限用</p>
                </div>
              </div>
            </div>
            <div className='info-block'>
                <div className='title'>提供優惠的項目</div>
                {
                  data.service_list?.map(service =>(
                    <div className='block'>
                    <Image src={`/images/icons/${service.free_info==="V"?'done':'list'}.svg`} />
                    {
                      service.free_info==="V" ?(<p>{service.service_name}</p>):(<div>
                    <p>{service.service_name}</p>
                    <p className='desc'>{service.free_info}</p>
                  </div>)
                    }
                    
                  </div>
                  ))
                }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IdentityInfo